<div class="app-logs-container">
    <div class="interface-outer-container" *ngIf="env.user">
        <app-interface></app-interface>
    </div>

    <div class="login-page-container" *ngIf="!env.user">    
        <app-login-page></app-login-page>
    </div>
</div>
